import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/joy';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import observationActions from 'actions/observationActions'
import taxonomyNameActions from 'actions/taxonomyNameActions'
import alternateIdentifierActions from 'actions/alternateIdentifierActions'
import noteActions from 'actions/noteActions'
import evidenceActions from 'actions/evidenceActions'
import CommonUtils from 'utils/CommonUtils'

import Sheet from 'components/core/Sheet';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';
import Stack from 'components/core/Stack';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import ObservationDossier from 'components/ObservationDossier';
import EvidenceTable from 'components/EvidenceTable';
import EvidenceAddDialog from 'components/EvidenceAddDialog';

const ObservationView = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { observationId } = useParams();
    const observation = useSelector(({ observation }) => observation.current);
    const taxonomyNameSynonyms = useSelector(({ taxonomyName }) => taxonomyName.list);
    const alternateIdentifiers = useSelector(state => state.alternateIdentifier.list);
    const evidence = useSelector(({ evidence }) => evidence.list);

    const notes = useSelector(({ note }) => note.list);
    const [evidenceDialogOpen, setEvidenceDialogOpen] = useState(false);

    useEffect(() => {
        dispatch(observationActions.get(observationId)).then((getResult) => {
            if (!getResult) return;
            const observation = getResult.value
            dispatch(taxonomyNameActions.listSynonyms(observation?.get('name')?.get('taxonomy')))
            dispatch(noteActions.list({ observation: CommonUtils.createPointer('Observation', observation.id) }))
            dispatch(alternateIdentifierActions.list({taxonomy: observation?.get('name')?.get('taxonomy')}))
            dispatch(evidenceActions.listForObservation(observationId))
        })
    }, [observationId])

    useEffect(() => {
        return () => {
            dispatch(observationActions.clearList());
        };
    }, [dispatch]);

    if (!observation) {
        return null;
    }

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mx: { xs: 1, sm: 1, md: 5, lg: 10, xl: 30 }
            }}
        >
            <Sheet sx={{width: '100%', background: 'none'}}>
                <Button
                    variant="text" 
                    onClick={() => navigate(-1)}
                    sx={{ padding: 0}}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        <ArrowBackIosIcon
                            sx={{ color: 'black', fontSize: 18, mt: 2}}
                        />
                        <Typography sx={{ fontSize: 18 }}>Back</Typography>
                    </Stack>
                </Button>

            </Sheet>
            <ObservationDossier
                observation={observation}
                notes={notes}
                taxonomyNameSynonyms={taxonomyNameSynonyms}
                alternateIdentifiers={alternateIdentifiers}
            />
            <Sheet sx={{width: '100%', background: 'none'}}>
                <Stack
                    direction="row"
                    sx={{ mb: 2 }}
                    spacing={10}
                >
                    <Typography>
                        <Typography variant='h3'>
                            Evidence
                        </Typography>
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={1}
                        style={{ marginLeft: 'auto' }}
                    >
                        <Button onClick={() => setEvidenceDialogOpen(true)}>
                            + Add Evidence
                        </Button>
                        <EvidenceAddDialog
                            observationEvidence={evidence}
                            open={evidenceDialogOpen}
                            onClose={() => setEvidenceDialogOpen(false)}
                            observationId={observationId}
                        />
                    </Stack>
                </Stack>
            </Sheet>
            <EvidenceTable
                evidences={evidence}
                observation={observation}
            />
        </Stack>
    );
};

export default ObservationView;